var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyFill21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.284.656A.657.657,0,0,1,3.942,0H17.1a.657.657,0,0,1,.658.656q0,1.059-.045,2.016A3.938,3.938,0,1,1,16.226,10.4c-1.04,2.448-2.472,3.645-3.729,3.952v2.852l1.876.467a1.969,1.969,0,0,1,.707.335l2.419,1.81A.656.656,0,0,1,17.1,21H3.942a.656.656,0,0,1-.395-1.181l2.419-1.81a1.969,1.969,0,0,1,.707-.335l1.876-.467V14.355c-1.257-.307-2.689-1.5-3.729-3.953A3.938,3.938,0,1,1,3.33,2.671Q3.283,1.664,3.284.656Zm.13,3.334a2.625,2.625,0,1,0,.948,5.165A23.565,23.565,0,0,1,3.414,3.99ZM16.686,9.155a2.625,2.625,0,1,0,.948-5.165A23.707,23.707,0,0,1,16.686,9.155Z",
    transform: "translate(-0.021)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFill21);
export default __webpack_public_path__ + "static/media/trophy-fill-21.a3e92e0dc95dc597f49956631845fb37.svg";
export { ForwardRef as ReactComponent };